import { render, staticRenderFns } from "./IntroParagraph.vue?vue&type=template&id=70608cd1&scoped=true"
import script from "./IntroParagraph.vue?vue&type=script&lang=js"
export * from "./IntroParagraph.vue?vue&type=script&lang=js"
import style0 from "./IntroParagraph.vue?vue&type=style&index=0&id=70608cd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70608cd1",
  null
  
)

export default component.exports